<template>
  <header>
    <div class="left">

      <transition-group
          name="header-left"
          tag="div"
          class="transition"
      >
        <button
            v-if="showBackButton"
            class="back"
            @click="$emit('back')"
            key="0"
        >
          <img class="icon" src="./../assets/icon-back.svg" alt="back">
          <img class="icon-w" src="./../assets/icon-back-white.svg" alt="back">

          <span class="text">Nazaj</span>
        </button>

        <div class="brand" key=1>
          <img class="mob tw-max-w-none" @click="onLogoClicked()" src="./../assets/header-logo-green.svg">
          <img class="big" @click="onLogoClicked()" src="./../assets/header-logo.svg">
        </div>
      </transition-group>

    </div>

    <div class="right">

      <div
          class="buttons"
      >
        <p class="title">{{ headerTitle }}</p>
      </div>
    </div>

  </header>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "Header",
  props: {
    showBackButton: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapGetters(['headerTitle'])
  },
  methods: {
    onLogoClicked() {
      window.location.replace('https://www.triglavzdravje.si/');
    }
  }
}
</script>

<style scoped>

.header-left-enter-active,
.header-left-leave-active {
  transition: all 0.6s ease-in-out;
  overflow: hidden;
}

.header-left-enter.back,
.header-left-leave-to.back {
  opacity: 0;
  width: 0;
  margin-left: 0 !important;
  transform: translateX(-20px);
}

.header-left-leave.back {
  width: 50px;
}

.header-left-enter-to.back {
  opacity: 1;
  margin-left: 16px !important;
  width: 48px;
  transform: translateX(0);
}

@media (min-width: 280px) {
  header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;

    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100vw;
    height: 50px;

    font-family: Open Sans;
    color: #000;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: .03em;
    font-weight: 400;

    background-color: white;
    border-width: 0 0 1px;
  }

  header {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .1);
    -webkit-box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .1);
    -moz-box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .1);
  }

  header .left .transition {
    height: 100%;
    display: flex;
    align-items: center;
  }

  header .back {
    margin-left: 16px;

    display: flex;
    align-items: center;
  }

  header .back img {
    margin-right: 9px;
  }

  header .back img.icon-w {
    display: none;
  }

  header .back .text {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    font-family: Open Sans;
  }

  header .left {
    height: 100%;
    width: 100%;

    display: flex;
    align-items: center;
  }

  header .left .brand {
    display: inline-block;
    vertical-align: top;

    margin-left: 16px;

    overflow: hidden;
  }

  header .left .brand img {
    position: relative;
    width: 149px;
    height: 21px;
  }

  header .left .brand img.big {
    display: none;
  }

  header .left .divider-line {
    display: none;
  }

  header .right {
    display: none;
  }
}

@media screen and (min-width: 375px) {
  header .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  header .right p {
    margin: 0 16px 0 0;

    font-family: "Open Sans";
    font-size: 12px;
    line-height: 14px;
    text-align: right;
  }
}


@media screen and (min-width: 768px) {
  header .left {
    width: unset;
  }

  header .right {
    height: 51px;
    width: 590px !important;
  }

  header .right .title {
    font-size: 14px;
  }

  header .right .buttons {
    display: flex;
    justify-content: flex-end;
  }

  header .right .buttons .section {
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 15px 8px 12px 8px;
    margin: 0;
    height: 51px;

    cursor: pointer;
  }

  header .right .buttons .section .mask {
    width: 24px;
    height: 24px;
    background-color: #000;
    margin-right: 4px;
  }

  header .right .buttons .section p {
    font-family: Open Sans;
    font-size: 13px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: .03em;
    color: #4c4c4c;
    margin: 0;
  }

  header .right .buttons .section.skleni .mask {
    mask: url('./../assets/skleni-h.svg') no-repeat center / contain;
    -webkit-mask: url('./../assets/skleni-h.svg') no-repeat center / contain;
  }

  header .right .buttons .section.phone .mask {
    mask: url('./../assets/phone.svg') no-repeat center / contain;
    -webkit-mask: url('./../assets/phone.svg') no-repeat center / contain;
  }

  header .right .buttons .section.uveljavi .mask {
    mask: url('./../assets/uveljavi-icon.svg') no-repeat center / contain;
    -webkit-mask: url('./../assets/uveljavi-icon.svg') no-repeat center / contain;
  }

  header .right .spacer {
    display: inline-block;
    vertical-align: top;

    width: 1px;
    height: 20px;

    background: #ddd;
    padding: 0;
    margin: 14px 3px 0;
  }

  header .right .placeholder-blank {
    display: inline-block;
    vertical-align: top;
    width: 70px;
    margin-right: 6px;
  }

}


@media screen and (min-width: 1135px) {
  .header-left-leave.back {
    width: 75px;
  }

  .header-left-enter-to.back {
    width: 75px;
  }

  header {
    height: 63px;
    background: linear-gradient(93.81deg, #1ea89c, #006c68);
    border: none !important;
  }

  header .back img.icon {
    display: none;
  }

  header .back img.icon-w {
    display: block;
    width: 12px;
    height: 21px;
  }

  header .back .text {
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: white;
  }

  header .left {
    width: calc(100% - 590px);
  }

  header .left .menu-box {
    display: none;
  }

  header .left .brand {
    margin-left: 48px;
  }

  header .left .brand img {
    cursor: pointer;
  }

  header .left .brand img.mob {
    display: none;
  }

  header .left .brand img.big {
    display: block;
    width: 250px;
    height: 46px;
  }

  header .left .divider-line {
    display: inline-block;
    width: 1px;
    height: 60%;
    margin: 0 5px;

    position: relative;
    top: 20%;
    opacity: 0.5;

    background-color: white;
  }

  header .right {
    height: 63px;
    width: 590px;
  }

  header .right .title {
    color: #fff;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 1px;
    margin-right: 48px;
  }

  /*buttons*/
  header .right .buttons .section {
    vertical-align: top;
    height: 63px;
    padding: 16px 15px 17px;
  }

  header .right .buttons .section .mask {
    margin-right: 15px;

    background-color: #fff;
  }

  header .right .buttons .section.uveljavi .mask {
    width: 26px;
    height: 34px;
  }

  header .right .buttons .section.phone .mask {
    width: 25px;
    height: 26px;
  }

  header .right .buttons .section.skleni .mask {
    width: 35px;
    height: 25px;
  }

  header .right .buttons .section p {
    color: #fff;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 1px;
  }

  header .right .spacer {
    height: 25px;
    opacity: 0.25;
    width: 2.4px;
    margin-top: 18px;
    margin-right: 6.11px;
    margin-left: 6.11px;
  }

  header .right .placeholder-blank {
    width: 30px;
  }

  header .right .spacer.last {
    display: none;
  }
}

</style>
